var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attitudes-award-view"},[_c('SlideShowSection',{attrs:{"items":_vm.slidesAwards,"loading":_vm.loadingSlidesAwards}}),_c('AboutSection'),_c('TopicsSection'),_c('GalleriesSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }